<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="upsertMeasurement()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="measurement-wizard wrapper--spacing-vertical" data-test="measurement-wizard">
    <!-- Ration details -->
    <div *ngIf="measurement" class="measurement-wizard__ration-details spacing--margin-bottom">
      <agr-summary-card [title]="'measurements.wizard.ration-details.title' | translate">
        <div class="flex--column">
          <mat-form-field>
            <mat-label>{{ 'measurements.wizard.ration-details.name' | translate }}</mat-label>
            <input
              matInput
              formControlName="name"
              data-test="measurements-wizard__ration-details-name"
            />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'measurements.wizard.ration-details.type' | translate }}</mat-label>
            <mat-select
              hideSingleSelectionIndicator
              formControlName="type"
              data-test="measurements-wizard__ration-details-type"
            >
              <mat-option *ngFor="let type of types" [value]="type">
                {{ 'measurements.types.' + type | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Product">
            <mat-label>{{
              'measurements.wizard.ration-details.product-type' | translate
            }}</mat-label>
            <mat-select
              hideSingleSelectionIndicator
              formControlName="productType"
              data-test="measurements-wizard__ration-details-product-type"
            >
              <mat-option *ngFor="let productType of defaultProductTypes" [value]="productType">
                {{ 'measurements.product-types.' + productType | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.ration-type' | translate
            }}</mat-label>
            <mat-select
              hideSingleSelectionIndicator
              formControlName="rationType"
              data-test="measurements-wizard__ration-details-ration-type"
            >
              <mat-option *ngFor="let rationType of rationTypesForType" [value]="rationType">
                {{ 'measurements.ration-types.' + rationType | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field
            *ngIf="
              measurement.type === typeEnum.Ration ||
              (measurement.type === typeEnum.Product &&
                measurement.productType === productTypeEnum.Grass)
            "
          >
            <mat-label
              *ngIf="measurement.type === typeEnum.Product"
              data-test="measurements-wizard__silage-method-product-label"
              >{{ 'measurements.wizard.ration-details.silage-method' | translate }}</mat-label
            >
            <mat-label
              *ngIf="measurement.type === typeEnum.Ration"
              data-test="measurements-wizard__silage-method-ration-label"
              >{{
                'measurements.wizard.ration-details.silage-method-ration' | translate
              }}</mat-label
            >
            <mat-select
              hideSingleSelectionIndicator
              formControlName="silageMethod"
              data-test="measurements-wizard__ration-details-silage-method"
            >
              <mat-option *ngFor="let silageMethod of defaultSilageMethods" [value]="silageMethod">
                {{ 'measurements.silage-methods.' + silageMethod | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type !== typeEnum.Product">
            <mat-label>{{
              'measurements.wizard.ration-details.animal-group' | translate
            }}</mat-label>
            <mat-select
              hideSingleSelectionIndicator
              formControlName="species"
              data-test="measurements-wizard__ration-details-species"
            >
              <mat-option *ngFor="let speciesType of speciesForRationType" [value]="speciesType">
                {{ 'measurements.species.' + speciesType | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'measurements.wizard.ration-details.dm' | translate }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="dryMatter"
              data-test="measurements-wizard__ration-details-dm"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.percentage' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Restfeed">
            <mat-label>{{
              'measurements.wizard.ration-details.hours-after-feeding' | translate
            }}</mat-label>
            <input
              matInput
              formControlName="hoursAfterFeeding"
              placeholder="00:00"
              data-test="measurements-wizard__ration-details-hours-after-feeding"
            />
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.grass-silage' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="grassSilage"
              data-test="measurements-wizard__ration-details-grass-silage"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.maize-silage' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="maizeSilage"
              data-test="measurements-wizard__ration-details-maize-silage"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.structure-basal-ration' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="structureBasalRation"
              data-test="measurements-wizard__ration-details-structure-basal-ration"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.fresh-grass-basal-ration' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="freshGrassBasalRation"
              data-test="measurements-wizard__ration-details-fresh-grass-basal-ration"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'measurements.wizard.ration-details.ndf' | translate }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="1"
              formControlName="ndf"
              data-test="measurements-wizard__ration-details-ndf"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.gramsPerKgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.basal-ration' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="basalRation"
              data-test="measurements-wizard__ration-details-basal-ration"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.separate-fresh-grass' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.1"
              formControlName="separateFreshGrass"
              data-test="measurements-wizard__ration-details-separate-fresh-grass"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kgDM' | translate }}
            </span>
          </mat-form-field>

          <mat-form-field *ngIf="measurement.type === typeEnum.Ration">
            <mat-label>{{
              'measurements.wizard.ration-details.separate-concentrates' | translate
            }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              formControlName="separateConcentrates"
              data-test="measurements-wizard__ration-details-separate-concentrates"
            />
            <span matTextSuffix>
              {{ 'measurements.wizard.kg' | translate }}
            </span>
          </mat-form-field>
        </div>
      </agr-summary-card>
    </div>

    <div class="spacing--margin-bottom" *ngIf="measurement?.type === typeEnum.Ration">
      <agr-summary-card [title]="'measurements.wizard.loading-order.title' | translate">
        <app-measurement-loading-order
          [loadingOrder]="measurement.input?.componentLoadingOrder"
          [mixingTime]="measurement.input?.mixingTime"
          (loadingOrderChange)="processLoadingOrderChange($event)"
          (mixingTimeChange)="processMixingTimeChange($event)"
          (mixingTimeIsValidChange)="mixingTimeIsValid = $event"
        >
        </app-measurement-loading-order>
      </agr-summary-card>
    </div>

    <!-- Analyses - Fresh measurement or [fresh and dry] measurements -->
    <div class="spacing--margin-bottom">
      <agr-summary-card
        [title]="'measurements.wizard.analysis.fresh' | translate"
        data-test="fresh-analysis"
      >
        <app-measurement-analysis
          [analysis$]="freshAnalysis$"
          (analysisChange)="processAnalysisChange($event)"
          (analysisIsValidChange)="freshAnalysisIsValid = $event"
        >
        </app-measurement-analysis>
      </agr-summary-card>
    </div>

    <div
      class="spacing--margin-bottom"
      *ngIf="
        measurement.type !== typeEnum.Product &&
        (!measurement?.input ||
          measurement.input.dmPercentage < minDsPercentageForOnlyFreshAnalysisView)
      "
    >
      <agr-summary-card
        [title]="'measurements.wizard.analysis.dry' | translate"
        data-test="dry-analysis"
      >
        <mat-slide-toggle
          *ngIf="measurement.type === typeEnum.Restfeed"
          [(ngModel)]="showRestfeedDryAnalysis"
          [ngModelOptions]="{ standalone: true }"
          (change)="processToggleChange($event)"
          color="primary"
        >
          {{ 'measurements.wizard.analysis.show-restfeed-dry-analysis' | translate }}
        </mat-slide-toggle>

        <div
          class="spacing--margin-top"
          *ngIf="measurement.type !== typeEnum.Restfeed || showRestfeedDryAnalysis"
        >
          <app-measurement-analysis
            [analysis$]="dryAnalysis$"
            (analysisChange)="processAnalysisChange($event)"
            (analysisIsValidChange)="dryAnalysisIsValid = $event"
            [required]="false"
          >
          </app-measurement-analysis>
        </div>
      </agr-summary-card>
    </div>
  </div>
</agr-form-dialog>
